import { render, staticRenderFns } from "./kafa-form-error.vue?vue&type=template&id=7dbb56cd&lang=pug"
import script from "./kafa-form-error.vue?vue&type=script&setup=true&lang=js"
export * from "./kafa-form-error.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports